const menuItems = [
        { 
            "img": "images/soup1.jpg",
            "title": "Won Ton Soup with Chicken",
            "content": "chicken-stuffed won tons in clear chicken broth with white meat chicken pieces and a few scallions",
            "type": 'N',
        },
        { 
            "img": "images/soup2.jpg",
            "title": "Hot and Sour Soup",
            "content": "tofu, chicken, mushroom, bamboo shoot, and egg",
            "type": 'V',
        },
        { 
            "img": "images/Cm1.jpg",
            "title": "Veal Chow Mein",
            "content": "veal sauteed with bean sprouts, onions, and celery in brown sauce",
            "type": 'V',
        },
        { 
            "img": "images/DS1.jpg",
            "title": "Chocolate Truffle Cake",
            "content": "bean sprouts, onions, and celery in brown sauce",
            "type": 'V',
        },
        { 
            "img": "images/DS2.jpg",
            "title": "Cappuccino Apricot Cake",
            "content": "This decadent Cappuccino Cake has a soft texture, coffee flavour and a sweet coffee drizzle icing. It’s the perfect dessert or snack for coffee lovers.",
            "type": 'V',
        },
        { 
            "img": "images/FR1.jpg",
            "title": "Vegetable Fried Rice",
            "content": "broccoli, snow peas, onions, and bean sprouts sauteed with rice",
            "type": 'V',
        },
        { 
            "img": "images/FR2.jpg",
            "title": "Chicken Fried Rice",
            "content": "Chicken fried rice is the comfort dish of Chinese food. It's been around for a very long time and is also common many cuisines.",
            "type": 'N',
        },
        { 
            "img": "images/L11.jpg",
            "title": "Hunan Chicken",
            "content": "Hunan Chicken is a favorite Chinese American stir fry made with juicy, thinly sliced chicken breasts, broccoli, carrots, ....",
            "type": 'N',
        },
        { 
            "img": "images/NL.jpg",
            "title": "Beef Lo Mein",
            "content": "Lo mein is a Chinese dish with egg noodles. It contains vegetables and some type of meat or seafood, usually beef, chicken, pork, ...",
            "type": 'N',
        },
        { 
            "img": "images/SO2.jpg",
            "title": "French Fries",
            "content": "French fries are downright addictive and the perfect food for almost any occasion: a side at a cookout, a midday snack or a late-night wine session.",
            "type": 'V',
        },
        { 
            "img": "images/SP7.jpg",
            "title": "Orange Chicken and Beef Combo",
            "content": "Chinese orange chicken made with crispy fried chicken covered in an authentic orange sauce. The ultimate Chinese orange chicken recipe  is way better than take-out. ",
            "type": 'N',
        }

    ]

export default menuItems;